<template>

    <div class="head-cart-item row" v-bind:class="{ disable: product.attributes.salable === false }">
        <div class="head-cart-item-image col-xs-3">
            <a v-bind:href="product.attributes.detail_url">
                <img v-bind:src="product.attributes.pic_url" />
            </a>
        </div>
        <div class="head-cart-item-info col-xs-5">
            <a v-bind:href="product.attributes.detail_url">
                <b>{{ product.attributes.name }}</b>
            </a>
            <div>{{ strings['quantity'] }}: {{ product.quantity }}</div>
            <div>{{ strings['size'] }}: {{ product.attributes.size }}</div>
            <div v-if="product.attributes.description_color !== ''">{{ strings['color'] }}: {{ product.attributes.description_color }}</div>
        </div>
        <div class="head-cart-item-numbers col-xs-3">
            <div v-if="product.attributes.is_on_sale" class="head-cart-item-baseprice">
                {{ currency }} {{ product.attributes.base_price }}
            </div>
            <div v-else-if="product.attributes.is_on_promo" class="head-cart-item-baseprice before-promo">
                {{ currency }} {{ product.attributes.price_original }}
            </div>
            <div class="head-cart-item-price" v-if="product.attributes.salable">
                {{ currency }} {{ product.attributes.price }}
            </div>
        </div>
        <div class="head-cart-item-actions col-xs-1" v-bind:class="{ updating: product.updating }">
            <span v-on:click="$emit('remove')"><i class="fal fa-times"></i><i class="far fa-spinner-third fa-spin"></i></span>
        </div>
        <div class="head-cart-item-notsalable col-xs-12" v-if="product.attributes.salable === false">{{ strings['price_error'] }}</div>
    </div>
</template>

<script>
module.exports = {
    props: ['product', 'currency', 'strings'],
}
</script>
